<template>
  <div class="usercenter-con">
    <div class="card-list z-flex">
      <div class="card-item" v-for="(item,index) in cardList" :key="index">
        <div class="name">{{item.name}}</div>
        <div class="num">剩余<span>{{item.num}}</span>张</div>
        <div class="deadline">截止：{{item.deadLine}}</div>
      </div>
    </div>
    <el-table class="table-list" :data="tableData" stripe border>
      <el-table-column prop="orderNo" label="订单号"></el-table-column>
      <el-table-column prop="name" label="套餐名称" width="500"></el-table-column>
      <el-table-column prop="price" label="充值金额（元）"></el-table-column>
      <el-table-column prop="createTime" label="订单时间"></el-table-column>
      <el-table-column prop="endTime" label="到期时间"></el-table-column>
      <!-- 无数据 -->
      <div slot="empty">
        <defaultCon
          :defaultImg="noDataOp.defaultImg" 
          :defaultText="noDataOp.defaultText" 
          :defaultBtnList="noDataOp.defaultBtnList" 
        >
        </defaultCon>
      </div>
    </el-table>
  </div>
</template>
<script>
  import {mapGetters, mapMutations} from "vuex";

export default {
  inject:['setTab'], //tab选中
  data() {
    return {
      cardList:[],
      tableData: [],
      noDataOp:{ //无列表数据
        defaultImg:require('@/assets/img/nodata.png'),
        defaultText:'您还没有套餐，快去选购吧！',
        defaultBtnList:[
          {
            btnText:'选购套餐',
            btnUrl:'/vip',
            ifRoute:true,
          },
        ],
      }
    };
  },
  mounted:function () {
    this.setTab(0) //tab选中

    var _self = this;
    this.$axios.post('/api/v1/user/comboRecord').then(res => {
      if (res.status == 200 && res.data.code == 1) {
        var data = res.data.data;
        data.list.filter(function (item) {
          _self.tableData.push({
            orderNo: item.out_trade_no,
            name: item.name,
            price: item.price,
            createTime: item.createtime,
            endTime: item.endtime,
          });
          if (item.state == 1) {
            _self.cardList.push({
              name: item.name,
              num: item.combo_num,
              deadLine: item.endtime
            });
          }
        });
        console.log(data);
      }
    }).catch(error => {
      console.log(error);
    });

  },
  methods: {

  },
};
</script>
<style lang="scss" scoped>
  .card-list{
    width:1620px;
    margin: 20px 0;
    .card-item{
      overflow: hidden;
      width:420px;
      height:230px;
      margin:0 20px 20px 0;
      background: url('../../assets/img/vip-card.png');
      .name{
        color: #fff;
        font-size: 20px;
        background:#b96e0e;
        margin-top: 30px;
        height:36px;
        line-height:36px;
        letter-spacing: 2px;
        display:inline-block;
        padding:0 20px;
        border-bottom-right-radius: 18px;
        border-top-right-radius: 18px;
      }
      .num{
        text-align: center;
        font-size: 32px;
        color: #713a00;
        margin-top: 22px;
        letter-spacing: 2px;
        span{
          font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
          font-size: 52px;
          margin:0 15px;
        }
      }
      .deadline{
        color: #794400;
        font-size: 16px;
        margin: 30px 0 0 20px;
      }
    }
  }
</style>
